export default "__VITE_ASSET__BRFMXW1V__"